<template>
  <aside
      id="sidenav-main"
      class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 ms-3"
      :class="`${isRTL ? 'me-3 rotate-caret fixed-end' : 'fixed-start ms-3'} ${sidebarType}`"
  >
    <div class="sidenav-header">
      <i
          class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-xl-none"
          aria-hidden="true"
          id="iconSidenav"
          @click="closeSidenav"
      ></i>

      <!-- Sidebar Logo: independently styled -->
      <a class="m-0 navbar-brand" href="/dashboard">
        <img
            :src="sidebarType === 'bg-white' || (sidebarType === 'bg-transparent' && !isDarkMode) ? logoDark : logo"
            class="sidebar-logo"
            alt="Rocket Admin Sidebar Logo"
        />
      </a>
    </div>

    <hr class="horizontal light mt-0 mb-2" />
    <sidenav-list />
  </aside>
</template>

<script>
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/gemini-svg.svg";
import logoDark from "@/assets/gemini-svg.svg"; // Replace with actual dark version if needed
import { mapState, mapMutations } from "vuex";

export default {
  name: "index",
  components: {
    SidenavList,
  },
  data() {
    return {
      logo,
      logoDark,
    };
  },
  computed: {
    ...mapState(["isRTL", "sidebarType", "isDarkMode"]),
  },
  methods: {
    ...mapMutations(["closeSidenav"]),
  },
};
</script>

<style scoped>
.sidebar-logo {
  height: 120px; /* ⬆️ Increased height */
  object-fit: contain;
  display: block;
  margin: 0 auto;
  margin-top: -35px;   /* Adjusted vertical spacing */
  padding-bottom: 6px;
}

</style>
